import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer, Span, ProgressBox, ProgressStat } from '../styles';
import { polarColors } from '../constants';

const getColor = value => {
  if (value < 25) {
    return polarColors[4];
  }
  if (value < 50) {
    return polarColors[3];
  }
  if (value < 75) {
    return polarColors[1];
  }
  return polarColors[0];
};

const getSumFomValues = (values = []) => {
  const sum = values
    .filter(Boolean)
    .reduce((acc, curr) => acc + parseFloat(curr), 0);
  return sum;
};

const getMeanFromValues = (values = []) => {
  const sum = getSumFomValues(values);
  const mean = sum / values.length;
  return mean;
};

const DysfunctionalBeliefsFirstPage = ({ background, number, user }) => {
  // console.log({ user });

  const fallBackMotivation = getMeanFromValues([
    10 - parseFloat(user['MOT_01']), // reverse
    parseFloat(user['MOT_02']),
    10 - parseFloat(user['MOT_03']), // reverse
    parseFloat(user['MOT_04'])
  ]);
  const motivation = parseFloat(user['Motivación']) || fallBackMotivation;

  const motivationPercent = user['Motivación']
    ? motivation
    : (motivation / 9) * 100;
  // console.log({ motivation, motivationPercent });

  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h1>3. Características del proceso de toma de decisión de carrera</h1>
          <p className='justified'>
            En esta sección podrás identificar alguna de tus características al
            tomar decisiones y algunas dificultades asociadas a tu proceso de
            toma de decisión de carrera. Esta información te puede ayudar a
            decidir qué aspectos debes revisar o qué estrategias debes
            implementar para enfrentar de mejor manera este proceso y sentirte
            más seguro/a con tu decisión.
          </p>

          {user['MOT_01'] && (
            <>
              <h2>3.1. Motivación por el Proceso</h2>
              <p className='justified'>
                Se refiere al{' '}
                <strong>
                  impulso interno que nos lleva a participar activamente en la
                  exploración de alternativas y toma de decisiones sobre nuestro
                  futuro profesional
                </strong>
                . Es un factor fundamental para iniciar y mantenerse
                comprometido/a en este proceso de elección. Entendemos que este
                momento puede ser abrumador y desafiante, por lo que si no
                encuentras una motivación para embarcarte en este desafío, es
                posible que postergues la decisión, no quieras participar de
                actividades que te podrían ayudar a orientarte, o tomes una
                decisión a la ligera.
              </p>
              <p className='justified'>
                Resultados en
                <Span strong color={polarColors[0]}>
                  {' '}
                  ROJO{' '}
                </Span>
                sugieren un bajo nivel de motivación por el proceso de toma de
                decisiones vocacional y resultados en{' '}
                <Span strong color={polarColors[4]}>
                  VERDE
                </Span>{' '}
                sugieren que tienes un buen nivel de motivación por participar
                en este proceso.
              </p>
              <p className='justified'>
                Si obtienes bajos puntajes en esta área, es importante recordar
                que <strong>la motivación puede desarrollarse</strong>, para lo
                cual es clave reflexionar en torno a tus intereses y metas
                personales,{' '}
                <strong>
                  para identificar aquellas cosas que te pueden resultar más
                  atractivas dentro del proceso de toma de decisiones de carrera
                </strong>
                , y que te puedan servir para involucrarte de forma más activa
                en este proceso.
              </p>
              <div className='progress-info-group'>
                <div className='progress-info'>
                  <div className='progress-details-single'>
                    <ProgressBox
                      progress={motivationPercent}
                      backColor={() => getColor(100 - motivationPercent)}
                    >
                      <div className='progress'></div>
                    </ProgressBox>
                    <ProgressStat>{motivationPercent.toFixed(0)}</ProgressStat>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default DysfunctionalBeliefsFirstPage;
